import(/* webpackMode: "eager" */ "/codebuild/output/src1540936391/src/apps/web/app/[locale]/error.tsx");
